<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2233_49285)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.585786 5.08579C0 5.67157 0 6.61438 0 8.5V13.5C0 15.3856 0 16.3284 0.585786 16.9142C1.17157 17.5 2.11438 17.5 4 17.5H18C19.8856 17.5 20.8284 17.5 21.4142 16.9142C22 16.3284 22 15.3856 22 13.5V8.5C22 6.61438 22 5.67157 21.4142 5.08579C20.8284 4.5 19.8856 4.5 18 4.5H4C2.11438 4.5 1.17157 4.5 0.585786 5.08579ZM3.35242 6.85242C2.80013 6.85242 2.35242 7.30013 2.35242 7.85242V14.1476C2.35242 14.6999 2.80013 15.1476 3.35242 15.1476H9.64758C10.1999 15.1476 10.6476 14.6999 10.6476 14.1476V7.85242C10.6476 7.30013 10.1999 6.85242 9.64758 6.85242H3.35242Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2233_49285">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
